import { Controller } from '@hotwired/stimulus';
import $ from 'jquery';
import TomSelect from 'tom-select';

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static targets = ['selectInput'];

    static values = {
        labels: String,
    };

    tomselect = null;

    get _renderLabels() {
        try {
            return JSON.parse(this.labelsValue);
        } catch {
            return {};
        }
    }

    openModal() {
        if (!this.selectInputTarget.tomselect) {
            this.tomselect = new TomSelect(this.selectInputTarget, {
                controlInput: null,
                allowEmptyOption: true,
                render: {
                    option: (data, escape) => {
                        if (!data.value) {
                            return `<div class="py-1 text-muted">${escape(data.text)}</div>`;
                        }

                        return `<div class="py-1">${this._renderLabels[data.value] ?? escape(data.text)}</div>`;
                    },
                    item: (data, escape) => {
                        if (!data.value) {
                            return `<div class="text-muted">${escape(data.text)}</div>`;
                        }

                        return `<div>${this._renderLabels[data.value] ?? escape(data.text)}</div>`;
                    },
                },
            });
        }

        $(this.element).modal({
            backdrop: 'static',
            focus: false,
            show: true,
        });
    }

    disconnect() {
        if (this.tomselect) {
            this.tomselect.destroy();
            this.tomselect = null;
        }
    }

    save() {
        const value = this.selectInputTarget.tomselect
            ? this.selectInputTarget.tomselect.getValue()
            : this.selectInputTarget.value;

        showPreloader();

        $.ajax({
            method: 'POST',
            url: routes['app_profile_numberofemployeesfieldupdate'],
            data: { number_of_employees: value },
            success: (response) => {
                if (response.status) {
                    $(this.element).modal('hide');

                    dataLayer.push({
                        event: 'dataLayer.gaEvent',
                        gaEvent: {
                            'category': 'Account',
                            'action': 'profile_number_of_employees_modification',
                            'label': '',
                        },
                    });

                    window.location.reload();
                } else {
                    hidePreloader();
                    addAlert('danger', translations['profile.An unknown error occurred.']);
                }
            },
            error: function() {
                hidePreloader();
                addAlert('danger', translations['profile.An unknown error occurred.']);
            },
        });
    }
}
